import { SCREEN_READER_DATA } from '../../actionTypes/Notifications/Notifications';

export const setScreenReaderMsg = (attributes) => {
  return (dispatch) => {
    dispatch({ type: SCREEN_READER_DATA, payload: attributes });
  };
};

export const setNavigateToMsg = (msg) => {
  return setScreenReaderMsg({ text: `Navigated to ${msg} page` });
};

export const setSrLoadedMsg = (msg) => {
  return setScreenReaderMsg({ text: `Loaded ${msg} page` });
};
